<template>
  <div class="bind-menu">
    <el-dialog
      title="职务绑定功能"
      :visible="bindShow"
      width="40%"
      @close="dialogClose"
      @open="dialogOpen"
    >
      <el-form label-width="100px" style="max-height: 450px; overflow: auto">
        <el-form-item label="职务名称">
          <el-input
            v-model="jobItemData.jobName"
            autocomplete="off"
            placeholder="请输入职务名称"
            style="width: 235px"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="功能列表">
          <el-cascader
            v-model="menuIds"
            :value="menuIds"
            @change="selectParentMenu"
            placeholder="请选择功能菜单"
            :options="menuData"
            :props="{ multiple: true, checkStrictly: false }"
            clearable
            collapse-tags
          >
          </el-cascader>
        </el-form-item>
      </el-form>
      <div class="form-btn">
        <!-- <el-button @click="dialogClose">取 消</el-button> -->
        <el-button type="primary" @click="confirm" v-hasPermi="'sc:jobmenu:add'"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "",
  props: ["bindShow", "jobItemData", "menuList", "jobMenuIds"],
  data() {
    return {
      selectList: [],
      placeholder: "请输入教师姓名",
      menuName: "",
      indexArray: [],
      menuData: [{ value: 0, label: "主类目", children: [] }],
      menuIds: [],
    };
  },
  created() {},
  mounted() {
    // this.menuIds = this.jobMenuIds;
    this.menuData[0].children = this.menuList;
    this.selectMenuBasedOnValues();
  },
  methods: {
    selectMenuBasedOnValues() {
      let arr = this.jobMenuIds;
      this.menuData.forEach((firstLevel) => {
        firstLevel.children.forEach((secondLevel) => {
          if (!secondLevel.children) return;
          secondLevel.children.forEach((thirdLevel) => {
            if (arr.includes(thirdLevel.value)) {
              this.menuIds.push([firstLevel.value, secondLevel.value, thirdLevel.value]);
            }
            if (!thirdLevel.children) return;
            thirdLevel.children.forEach((forthLevel) => {
              if (arr.includes(forthLevel.value)) {
                this.menuIds.push([
                  firstLevel.value,
                  secondLevel.value,
                  thirdLevel.value,
                  forthLevel.value,
                ]);
              }
            });
          });
        });
      });

      // console.log(this.menuData, this.menuIds);
    },
    selectParentMenu(e) {
      // console.log(this.form.parentMenuList);
    },
    // 关闭弹出窗口
    dialogClose() {
      this.$emit("update:bindShow", false);
    },
    dialogOpen() {},
    confirm() {
      // console.log("this.menuIds==>", this.menuIds);
      /// 将多维数组展开为一维数组
      const flatArray = this.menuIds.flat();

      // 使用 Set 来去重
      const uniqueValues = new Set(flatArray);

      // 将 Set 转换回数组形式
      const newMenuIds = Array.from(uniqueValues);
      // console.log("newMenuIds==>", newMenuIds);
      let data = {
        jobId: this.jobItemData.id,
        menuIds: newMenuIds,
      };
      this.$emit("bindMenuSubmit", data);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./bind-menu.scss";
</style>
